

Handlebars.registerHelper('decimal', function(number, digits) {
  return Number(parseFloat(number).toFixed(digits));
});

Handlebars.registerHelper('slicedash', function(data, index) {
  return data.split('-')[index]
});

Handlebars.registerHelper('date_format', function(date_str) {
  return moment(date_str).format('llll');
});

Handlebars.registerHelper('def', function(value, d) {
  if (value) {
    return value;
  } else {
    return d;
  }
});



Handlebars.registerHelper('eq', function () {
    const args = Array.prototype.slice.call(arguments, 0, -1);
    return args.every(function (expression) {
        return args[0] === expression;
    });
});
console.log("test eq");
Handlebars.registerHelper('not', function () {
    const args = Array.prototype.slice.call(arguments, 0, -1);
    return args.every(function (expression) {
        return args[0] !== expression;
    });
});


(function ($) {
    $.fn.serializeFormJSON = function () {

        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };
})(jQuery);
